
export const useBanner = () => {
  const rootStore = useRootStore()

  const { previousRoute } = storeToRefs(rootStore)

  let pageBannerData = null

  let updateInClientLifecycle = 'mounted'

  const updatePageBanner = () => {
    if (pageBannerData) {
      rootStore.SET_PAGE_BANNER(pageBannerData)
    }
  }

  onBeforeMount(() => {
    if (updateInClientLifecycle !== 'beforeMount') {
      return
    }

    updatePageBanner()
  })

  onMounted(() => {
    if (updateInClientLifecycle !== 'mounted') {
      return
    }

    updatePageBanner()
  })

  const route = useRoute()

  /**
   * Made to sync updates in layout banner with page change
   */
  const setPageBanner = (bannerData, onlyClient) => {
    if (!onlyClient && import.meta.server) {
      rootStore.SET_PAGE_BANNER(bannerData)
      return
    }

    if (previousRoute.value && previousRoute.value.name === route.name) {
      updateInClientLifecycle = 'beforeMount'
    }

    pageBannerData = bannerData
  }

  return {
    setPageBanner,
  }
}
